import { render, staticRenderFns } from "./createBannerLocker.vue?vue&type=template&id=0fab2221&"
import script from "./createBannerLocker.vue?vue&type=script&lang=js&"
export * from "./createBannerLocker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports